module.exports = __webpack_public_path__ + "img/D3.5843905e.png";